var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReport = function SvgReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#report_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "M10.928 3.23H7.5V1.715a.43.43 0 0 0-.429-.429H1.607V.752A.107.107 0 0 0 1.5.645H.75a.107.107 0 0 0-.107.107v10.5c0 .059.048.107.107.107h.75a.107.107 0 0 0 .107-.107V7.716h3.321v1.513c0 .237.192.429.429.429h5.571a.43.43 0 0 0 .429-.429V3.658a.43.43 0 0 0-.429-.429M1.607 6.751v-4.5h4.928v4.5zm8.786 1.942h-4.5v-.978h1.5a.107.107 0 0 0 .107-.107V4.194h2.893z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "report_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgReport;